import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Leads from './pages/Leads';
import PagesForms from './pages/PagesForms';
import Templates from './pages/Templates';
import SettingsPage from './pages/Settings';
import Users from './pages/Users';

export default function App() {
  const { user, isLoading, isAdmin } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-gray-500">
        Načítám…
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Leads />} />
        <Route path="/pages" element={<PagesForms />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        {isAdmin && <Route path="/settings" element={<SettingsPage />} />}
        {isAdmin && <Route path="/users" element={<Users />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
